<h2 mat-dialog-title>{{ 'dialog-free-tier.title' | translate }}</h2>
<mat-dialog-content>
  <p>
    {{ 'dialog-free-tier.content' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'dialog-free-tier.button-later' | translate }}</button>
  <button mat-raised-button class="custom-form-btn" (click)="onGoToForm()">
    {{ 'dialog-free-tier.button-fill-form' | translate }}
  </button>
</mat-dialog-actions>